import type { ReactNode } from 'react';

export const symbol_falling: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m503-242-128-97q-8-7-14.5-15t-8.5-19l-50-219-105 90 25 118q2 13-4.5 23.5T198-348q-13 2-23.5-4.5T162-372l-24-117q-3-16 2-30.5t17-25.5l148-132q21-19 49-15t55 15q34 14 70 20.5t72 1.5q26-4 48-15t43-26q11-8 23.5-7t20.5 11q8 10 6.5 22T680-650q-22 16-44.5 28.5T587-601q-35 10-72 8t-72-11l33 150 129-25q12-2 23.5.5T650-469l151 107q11 8 12.5 20t-6.5 23q-8 10-19.5 12t-21.5-5L622-413l-170 34 91 67q14 11 20 26.5t3 32.5L537-92q-2 13-12.5 19.5T501-68q-13-2-19.5-12.5T477-104l26-138ZM270.5-780.5Q250-801 250-830t20.5-49.5Q291-900 320-900t49.5 20.5Q390-859 390-830t-20.5 49.5Q349-760 320-760t-49.5-20.5Z"
		/>
	</svg>
);
